import Vue from "vue";
import VueRouter from "vue-router";
import axios from 'axios';

import Home from "../components/Home.vue";
// 关于
import Story from "../components/About/Story.vue";
import About from "../components/About/Index.vue";
// 职业发展
import Socialpost from "../components/Occupation/Socialpost.vue";//社会招聘列表
import SocialDetail from "../components/Occupation/SocialDetail.vue";//社会招聘详情
import WinterCamp from "../components/Occupation/WinterCamp.vue";//冬令营
import Occupation from "../components/Occupation/Index.vue";//职业发展首页
import School from "../components/Occupation/School.vue";//校园招聘
import Interviewtips from "../components/Occupation/Interviewtips.vue";//佳油站
import Apply from "../components/Occupation/Apply.vue";//岗位申请
import PrivacyPolicy from "../components/Occupation/PrivacyPolicy.vue";//隐私政策
// 国家机遇
import Chinaopportunity from "../components/Chinaopportunity/Chinaopportunity.vue";//国家机遇
// 旗下产品product
import Product from "../components/Product/Index.vue";//旗下产品登录首页
import ProductList from "../components/Product/List.vue";//旗下产品首页
import ProductDetail from "../components/Product/Detail.vue";//旗下产品首页
// 社会责任
import Responsibility from "../components/Responsibility/Responsibility.vue";
// 联系我们
import Contact from "../components/Contact/Contact.vue";
// 搜索
import Search from "../components/Search/Search.vue";
import SearchDetail from "../components/Search/Detail.vue";
// 手机页面
// 合格协议
import PhoneAggrement from "../components/phonePage/Product/Agreement.vue";
// 产品登录页
// 登录页
import PhoneLogin from "../components/phonePage/Product/Login.vue";
// 邮箱找回
import EmailFind from "../components/phonePage/Product/EmailFind.vue";
// 手机号码找回
import PhoneFind from "../components/phonePage/Product/PhoneFind.vue";
// 找回密码
import FindPw from "../components/phonePage/Product/FindPw.vue";
// 问卷
import Questionnaire from "../components/Questionnaire/questionnaire.vue";
// 产品首页
// import PhoneProductList from "../components/phonePage/Product/ProductList.vue";
// 英文版跳转
import En from "../components/En/Index.vue";

import ManagerPage from "../components/ManagerPage.vue";
Vue.use(VueRouter);

const routes = [
  {
    name:'home',
    path: "/",
    redirect: "/home"
  },
  {
    name:'',
    path: "/home",
    component: Home
  },
  {
    name:'story',
    path: "/story",
    component: Story
  },
  {
    name:'about',
    path: "/about",
    component: About
  },
  {
    name:'positions',
    path: "/positions",
    component: Socialpost
  },
  {
    name:'socialDetail',
    path: "/socialDetail",
    component: SocialDetail
  },
  {
    name:'campus2022',
    path: "/campus2022",
    component: School
  },
  {
    name:'interviewtips',
    path: "/interviewtips",
    component: Interviewtips
  },
  {
    name:'chinaopportunity',
    path: "/chinaopportunity",
    component: Chinaopportunity
  },
  {
    name:'winterCamp',
    path: "/winterCamp",
    component: WinterCamp
  },
  {
    name:'apply',
    path: "/apply",
    component: Apply
  },
  {
    name:'privacyPolicy',
    path: "/privacyPolicy",
    component: PrivacyPolicy
  },
  {
    name:'careers',
    path: "/careers",
    component: Occupation
  },
  {
    name:'product',
    path: "/product",
    component: Product
  },
  {
    name:'productList',
    path: "/productList",
    component: ProductList
  },
  {
    name:'productDetail',
    path: "/productDetail",
    component: ProductDetail
  },
   {
    name:'responsibility',
    path: "/responsibility",
    component: Responsibility
  },
  {
    name:'contact',
    path: "/contact",
    component: Contact
  },
  {
    name:'search',
    path: "/search",
    component: Search
  },
  {
    name:'searchDetail',
    path: "/searchDetail",
    component: SearchDetail
  },
  {
    name:'phoneAggrement',
    path: "/phoneAggrement",
    component: PhoneAggrement
  },
  {
   name:'phoneLogin',
   path: "/phoneLogin",
   component: PhoneLogin
 },
 {
   name:'emailFind',
   path: "/emailFind",
   component: EmailFind
 },
 {
   name:'phoneFind',
   path: "/phoneFind",
   component: PhoneFind
 },
 {
   name:'findPw',
   path: "/findPw",
   component: FindPw
 },
 {
    name:'en',
    path: "/en",
    component: En
  },
  {
    name:'questionnaire',
    path: "/questionnaire",
    component: Questionnaire
  },
];



const router = new VueRouter({
  mode: "history",
  routes
});

//抛出router之前，为其挂载路由导航守卫，to去哪，from从何来，next通行函数
router.beforeEach((to, from, next) => {
  // if (to.path === "/login") return next();
  // const tokenStr = window.sessionStorage.getItem("token");
  // if (!tokenStr) return next("/login");
next();
 // axios.get('http://47.116.134.87:18901/navigation/getNavigation.do').then(res=>{
 //  let list = res.data.data;
 //  let item = {
 //    name:'',
 //    path:'',
 //    component:''
 //  }
 //  list.map(e=>{
 //    var index=e.url.lastIndexOf("/");
 //    item.name =e.url.substring(index+1,e.url.length);
 //    item.path = e.url;
 //    item.component = item.name.charAt(0).toUpperCase()+item.name.slice(1);
 //  })
 // })
});

export default router;
